// extracted by mini-css-extract-plugin
export default {"container__criarproduto":"CriarProduto_container__criarproduto__msdw3","form__create":"CriarProduto_form__create__KJ4Hb","back__btn":"CriarProduto_back__btn__hLhac"};